import { ApiImage } from '@ibe/api';
import { observer } from 'mobx-react';
import { ItemFrame } from '../../../../../Models/ItemFrame';
import React, { ReactNode, useState, MouseEvent } from 'react';
import { Card, CardBody, CardImg, CardImgOverlay, Col, Row } from 'reactstrap';

export interface Props {
  image?: ApiImage;
  imageOverlay?: ReactNode;
  placeholderImage: string;
  leftContent?: ReactNode;
  headline?: ReactNode;
  center?: ReactNode;
  travelDateSelect?: boolean;
  topRight?: ReactNode;
  midRight?: ReactNode;
  bottomRight?: ReactNode;
  button?: ReactNode;
  onClick?: (e: MouseEvent<HTMLElement>) => void;
  fullAreaClick?: boolean;
  mobileViewInLg?: boolean;
  frame?: ItemFrame;
  onCardClick?: () => void;
}

const ThreeColumnListItemLayout = observer((props: Props) => {
  const {
    image,
    imageOverlay,
    placeholderImage,
    leftContent,
    headline,
    center,
    topRight,
    midRight,
    bottomRight,
    button,
    onClick,
    fullAreaClick,
    mobileViewInLg,
    frame,
    onCardClick
  } = props;
  const [imageUrl, setImageUrl] = useState<string>(image?.url || '');

  return (
    <div className={`${frame?.enableFrame ? 'iso__three-column-list-item-layout__frame' : ''}`}>
      {frame?.enableFrame && (
        <div className={'iso__three-column-list-item-layout__frame__text'}>
          <span className={`${frame?.frameColor && frame?.frameColor.toLowerCase()}`}>
            {frame?.frameText}
          </span>
        </div>
      )}
      <Card
        className={`iso__three-column-list-item-layout${
          fullAreaClick ? ' iso__three-column-list-item-layout--full-area' : ''
        }`}
        onClick={(e: MouseEvent<HTMLElement>): void => {
          e.stopPropagation();
          if (fullAreaClick && onClick) {
            onClick(e);
          }
        }}
      >
        <Row noGutters className={'iso__three-column-list-item-layout__outer-wrapper'}>
          <Col
            md={mobileViewInLg ? 12 : 3}
            xl={3}
            className={imageUrl ? 'iso__three-column-list-item-layout__wrapper' : ''}
          >
            {!imageUrl && leftContent && <>{leftContent}</>}
            {imageUrl && (
              <>
                <CardImg
                  className="iso__three-column-list-item-layout__wrapper__img"
                  src={imageUrl}
                  variant="top"
                  alt={image?.altText || 'Picture'}
                  onError={(): void => setImageUrl(placeholderImage)}
                />
                {imageOverlay && <CardImgOverlay>{imageOverlay}</CardImgOverlay>}
              </>
            )}
            {!imageUrl && !leftContent && (
              <CardImg
                className="iso__three-column-list-item-layout__wrapper__img"
                src={placeholderImage}
                variant="top"
                alt="Placeholder"
              />
            )}
          </Col>
          <Col
            md={mobileViewInLg ? 12 : 6}
            xl={6}
            className="iso__three-column-list-item-layout__wrapper"
          >
            <CardBody className="iso__three-column-list-item-layout__content">
              <Row>
                <Col>
                  <div className="iso__three-column-list-item-layout__content__headline mt-2">
                    <span
                      onClick={(e): void => {
                        if (!fullAreaClick && onClick) {
                          e.stopPropagation();
                          onClick(e);
                        }
                      }}
                    >
                      {headline}
                    </span>
                  </div>
                </Col>
              </Row>
              <Row className="mt-1 mb-1 flex-grow-1 iso__three-column-list-item-layout__content__body">
                <Col onClick={onCardClick} data-action={'on-card-click'}>
                  {center}
                </Col>
              </Row>
            </CardBody>
          </Col>
          <Col
            md={mobileViewInLg ? 12 : 3}
            xl={3}
            className="iso__three-column-list-item-layout__info bg-white p-3"
          >
            <div
              className="d-flex flex-row flex-md-column justify-content-between h-100 justify-content-md-start iso__three-column-list-item-layout__info-inner"
              onClick={onCardClick}
              data-action={'on-card-click'}
            >
              {topRight && <div className="mb-2 mb-sm-5 mb-md-2 flex-grow-1">{topRight}</div>}
              {midRight && (
                <div className="iso__three-column-list-item-layout__info-inner__mid-right-container">
                  <div className="text-right">{midRight}</div>
                </div>
              )}
              {bottomRight && (
                <div className="iso__three-column-list-item-layout__info-inner__bottom-right-container">
                  <div className="text-right">{bottomRight}</div>
                </div>
              )}
            </div>
            <div className="iso__three-column-list-item-layout__button">{button}</div>
          </Col>
        </Row>
      </Card>
    </div>
  );
});

export default ThreeColumnListItemLayout;
